<script setup>
  import { useAuthStore } from '@stores/auth';
  import { useMenuStore } from '@stores/menu';

  const authStore = useAuthStore();
  const route = useRoute();
  const menuStore = useMenuStore();

  const showMenuLogger = computed(() => {
    return /^\/user\/protection$/.test(route.path) && authStore.isLoggedIn;
  });

  const showMenuLogger2 = computed(() => {
    return /^\/user\/protection\/.+$/.test(route.path);
  });

  const props = defineProps({
    teste: {
      type: Boolean,
      required: false,
      default: false
    }
  });
</script>

<template>
  <!-- Link de navegação para mobile -->
  <NuxtLink
    to="/user/protection"
    @click="menuStore.userClose()"
    :class="!showMenuLogger && showMenuLogger2 ? 'flex md:hidden' : 'hidden md:hidden'"
    class="flex text-sm items-center gap-2 mb-4 font-bold hover:text-gray-300"
  >
    <icon name="material-symbols:chevron-left" size="20" />
    <p>Voltar</p>
  </NuxtLink>

  <section class=" md:hidden"  v-if="!menuStore.menuUser && showMenuLogger" >
    <div class="flex items-center justify-center gap-4 max-h-32">
      <Icon name="fa6-solid:shield-heart" size="150" class="text-brand-primary" />
      <span>
        <p class="text-xs">
          <b class="text-brand-primary">Responsabilidade do Jogador!</b>
          Jogue com responsabilidade, defina limites e nunca comprometa seu bem-estar financeiro.
          <br />
          Use nossas ferramentas para manter o controle e garantir uma experiência saudável.
        </p>
      </span>
    </div>
  </section>

  <transition name="fade">
    <div
      class="flex flex-col gap-2 sm:gap-3 w-full md:min-w-72 md:max-w-72 md:mr-4 md:flex"
      :class="[
        showMenuLogger ? '' : 'hidden md:flex',
        menuStore.menuUser ? 'hidden md:flex' : 'flex md:flex'
      ]"
    >
      <UserPaginationMenu
        name="Controle de Limites"
        class="transition-all"
        icon="subway:equalizer-1"
        to-link="/user/protection"
        @click="menuStore.userOpen()"
      />
      <UserPaginationMenu
        name="Suspensão"
        class="transition-all"
        icon="mingcute:pause-fill"
        to-link="/user/protection/suspension"
      />
      <UserPaginationMenu
        name="Exclusão"
        class="transition-all bg-danger/20"
        icon="fa6-solid:plug-circle-xmark"
        to-link="/user/protection/exclusion"
      />
    </div>
  </transition>
</template>
